// extracted by mini-css-extract-plugin
export default {"projectDetailsLoader__container":"ProjectDetailsLoader_projectDetailsLoader__container__0GPx-","spinner":"ProjectDetailsLoader_spinner__i2Y4n"};